import { forwardRef } from "react";

export const TextField = forwardRef(function TextField(
  { label, error, testId, hint, className = "", ...props },
  ref,
) {
  return (
    <label className="block">
      {label && (
        <span className="mb-1.5 block text-sm font-medium text-brand-sec">{label}</span>
      )}
      <input
        ref={ref}
        data-testid={testId}
        className={`w-full rounded-field border bg-brand-surface px-4 py-3 text-[15px] text-brand-text placeholder:text-brand-muted outline-none transition-colors duration-200 focus:border-brand-accent ${
          error ? "border-red-500/60" : "border-brand-line"
        } ${className}`}
        {...props}
      />
      {hint && !error && <span className="mt-1 block text-xs text-brand-muted">{hint}</span>}
      {error && <span className="mt-1 block text-xs text-red-400">{error}</span>}
    </label>
  );
});

export function PrimaryButton({ children, className = "", ...props }) {
  return (
    <button
      className={`inline-flex w-full items-center justify-center gap-2 rounded-button bg-brand-accent px-6 py-3 text-[15px] font-semibold text-brand-on transition-transform duration-200 hover:-translate-y-0.5 disabled:cursor-not-allowed disabled:opacity-60 ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}
